import React from 'react';
import FaIcon from '../Elements/FaIcon';
import FigmaLink from '../Elements/FigmaLink';

export default class urlHelper {
  static getProperUrl(url = '', params) {
    if (!url) url = '';

    if (!url.startsWith('http')) url = `${window.location.origin}/${url}`;
    url += params ? `?${params}` : '';
    return url;
  }

  static addSearchParamsToUrl(searchItem, newSearchItem, urlMappedValues = []) {
    if (urlMappedValues === undefined) urlMappedValues = [];
    const searchElement = {};
    Object.keys(searchItem).forEach((key) => {
      if (key === 'SingleSearchLineText') return;
      if (
        searchItem !== undefined &&
        newSearchItem !== undefined &&
        (searchItem[key] !== newSearchItem[key] || urlMappedValues.includes(key))
      ) {
        if (Array.isArray(searchItem[key])) {
          if (JSON.stringify(searchItem[key]) !== JSON.stringify(newSearchItem[key])) {
            searchElement[key] = searchItem[key];
          }
        } else {
          // M: Checks if the element is a date, and only adds it to the search bar if the value is more than 600, which means at least an hour had passed since the previous page load.
          if (
            !(
              searchItem[key] &&
              searchItem[key].getMonth &&
              typeof searchItem[key].getMonth === 'function' &&
              newSearchItem[key] &&
              newSearchItem[key].getMonth &&
              typeof newSearchItem[key].getMonth === 'function' &&
              (Date.parse(newSearchItem[key]) - Date.parse(searchItem[key])) / 1000 < 600
            )
          ) {
            searchElement[key] = searchItem[key];
          }
        }
      }
    });

    if (Object.keys(searchElement).length === 0) {
      urlHelper.removeSearchParamsFromUrl();
    } else {
      // Serialize Date values into the URL the same way JSON.stringify serializes them for the
      // backend request (ISO string via toISOString) instead of URLSearchParams' default local
      // Date.toString(). Otherwise a reload restores a differently-formatted date string and the
      // search yields a different result even though the user changed nothing.
      const newParameters = new URLSearchParams(
        Object.entries(searchElement).map(([key, value]) => [
          key,
          value && typeof value.getMonth === 'function' && !isNaN(value) ? value.toISOString() : value,
        ])
      );
      if (window.location.pathname.includes('search')) {
        window.history.pushState(
          '',
          '',
          `${urlHelper.getProperUrl()}${window.location.pathname.split('/')[1]}/search?${newParameters}`
        );
      } else {
        window.history.pushState('', '', `${window.location.pathname}/search?${newParameters}`);
      }
    }
  }

  static removeSearchParamsFromUrl(originalUrl = '') {
    const url = window.location.href;
    if (url.includes('/search?')) {
      window.history.pushState(
        '',
        '',
        originalUrl === '' ? `${urlHelper.getProperUrl()}${window.location.pathname.split('/')[1]}` : originalUrl
      );
    }
  }

  static generateLeadSearchRedirectUrl(path, paramName, value) {
    return `${urlHelper.getProperUrl()}${path}/search?${paramName}=${encodeURIComponent(value)}`;
  }

  static generateRedirectUrlWithMultipleParameters(path, parameters) {
    let url = `${urlHelper.getProperUrl()}${path}/search?`;

    parameters.forEach((param) => {
      url += `${param.key}=${param.value}&`;
    });

    return url.slice(0, -1);
  }

  static getLinkComponent(linktext, url, params, tooltip) {
    if (!url) url = linktext;
    if (!url) url = '';

    const link = urlHelper.getProperUrl(url, params);
    return (
      <a
        href={link}
        target='_blank'
        rel='noopener noreferrer'
        data-toggle='tooltip'
        data-placement='top'
        title={tooltip}
      >
        {linktext}
      </a>
    );
  }

  static getIconLinkComponent(linktext, iconName, className, url, params, tooltip) {
    const link = urlHelper.getProperUrl(url, params);
    return (
      <a
        href={link}
        target='_blank'
        rel='noopener noreferrer'
        data-toggle='tooltip'
        data-placement='top'
        title={tooltip}
      >
        <FaIcon
          iconName={iconName}
          className={className}
          text={linktext}
        />
      </a>
    );
  }

  static getIconLinkComponentFigma(linktext, iconName, className, url, params, tooltip) {
    const link = urlHelper.getProperUrl(url, params);
    return (
      <a
        className='secondarylink'
        href={link}
        target='_blank'
        rel='noopener noreferrer'
        data-toggle='tooltip'
        data-placement='top'
        title={tooltip}
      >
        {linktext}
      </a>
    );
  }
  static getFigmaIconLinkComponent(linktext, iconName, className, url, params, tooltip) {
    return (
      <FigmaLink
        value={linktext}
        url={urlHelper.getProperUrl(url, params)}
        label={linktext}
      />
    );
  }

  static isUrlOnWhiteList(url) {
    url = url.replace('http://', '').replace('https://', '');
    const startOfUrl = url.substring(0, url.indexOf('/'));
    // console.log(startOfUrl);
    return urlHelper.urlWhiteList.includes(startOfUrl);
  }

  static urlWhiteList = [
    'caspianstage.bareinternational.com',
    'caspian.bareinternational.com',
    'bravostage.bareinternational.com',
    'bravo.bareinternational.com',
    'bareinternational.atlassian.net',
    'caspian2stage.bareinternational.com',
    '',
  ];
}
